import { computed, unref, type MaybeRef } from "vue";
import { createQuery } from "@/queries";
import { setFilters } from "@/features/search/api/search";
import type { DefineFiltersResponse } from "@/types/searchItemsTypes";

export const useDefineFiltersQuery = (searchText: MaybeRef<string | null | undefined>) => {
  return createQuery<DefineFiltersResponse>({
    key: computed(() => {
      const value = unref(searchText)?.trim();
      return value ? ["search", "define-filters", value] : null;
    }),
    fetcher: async () => {
      const value = unref(searchText);
      if (!value || !value.trim()) {
        throw new Error("search text is required");
      }
      const response = await setFilters(value);
      return response.data;
    },
    staleTime: 60 * 1000,
    enabled: computed(() => Boolean(unref(searchText)?.trim())),
  });
};

